module.exports = __webpack_public_path__ + "img/br19.113c56e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br19.jpg
// module id = 8jL/
// module chunks = 0